import { Link } from "react-router-dom";

const styleInput =
  "block w-full px-3 py-2.5 mt-2 text-gray-700 bg-white border border-gray-300 rounded-md focus:border-secondary-color-2 focus:outline-none focus:ring-2 focus:ring-primary-color";

const styleSelect =
  "block w-full px-3 py-2.5 mt-2 text-gray-700 bg-white border border-gray-300 rounded-md focus:border-secondary-color-2 focus:outline-none focus:ring-2 focus:ring-primary-color";

const styleCheckbox = "form-checkbox h-5 w-5 accent-primary-color-2";

const FormField = function (props) {
  const {
    id,
    name,
    type,
    minLength,
    maxLength,
    placeholder,
    errors,
    register,
    validation,
    toggleIcon,
    value,
    options,
    label,
    required,
    valueAsNumber,
    errorCheckbox,
    toLink,
    warning,
    rows,
    onChange,
    autoComplete,
  } = props;

  function renderField() {
    // eslint-disable-next-line default-case
    switch (type) {
      case "text":
      case "email":
      case "number":
      case "date":
      case "password":
        return (
          <div>
            <label
              className={`${label ? "visible text-sm" : "invisible"} ${
                errors[id] ? "text-red-500 dark:text-red-500" : "text-black"
              }`}
              htmlFor={id}
            >
              {label}
            </label>
            <input
              id={id}
              name={name}
              type={type}
              value={value}
              minLength={minLength}
              maxLength={maxLength}
              placeholder={placeholder}
              autoComplete={autoComplete}
              className={`${styleInput}
                ${errors[id] ? "border-red-500 border-2" : "border-gray-300"} `}
              {...register(id, {
                onChange: onChange,
                valueAsNumber: valueAsNumber,
                required: {
                  value: required,
                  message: (
                    <>
                      <span className="capitalize">{name}</span>
                      <span> es requerido.</span>
                    </>
                  ),
                },
                minLength: {
                  value: minLength,
                  message: `Mínimo ${minLength} caracteres`,
                },
                maxLength: {
                  value: maxLength,
                  message: `Máximo ${maxLength} caracteres`,
                },

                pattern: {
                  value: validation,
                  message: (
                    <>
                      <span className="capitalize">{name}</span>
                      {warning ? warning : <span> no es válido.</span>}
                    </>
                  ),
                },
              })}
            />
            {toggleIcon}
          </div>
        );

      case "textarea":
        return (
          <div>
            <label
              className={`${label ? "visible" : "invisible"} ${
                errors[id] ? "text-red-500 dark:text-red-500" : "text-black"
              }`}
              htmlFor={id}
            >
              {label}
            </label>
            <textarea
              id={id}
              name={name}
              value={value}
              rows={rows}
              placeholder={placeholder}
              className={`${styleInput}
                ${errors[id] ? "border-red-500 border-2" : "border-gray-300"} `}
              {...register(id, {
                required: {
                  value: required,
                  message: (
                    <>
                      <span className="capitalize">{name}</span>
                      <span> es requerido.</span>
                    </>
                  ),
                  maxLength: {
                    value: maxLength,
                    message: `Máximo ${maxLength} caracteres`,
                  },
                },

                pattern: {
                  value: validation,
                  message: (
                    <>
                      <span className="capitalize">{name}</span>
                      {warning ? warning : <span> no es válido.</span>}
                    </>
                  ),
                },
              })}
            />
          </div>
        );

      case "select":
        return (
          <>
            <label
              className={`${label ? "visible" : "invisible"} ${
                errors[id] ? "text-red-500 dark:text-red-500" : "text-black"
              }`}
              htmlFor={id}
            >
              {label}
            </label>
            <select
              id={id}
              value={value}
              className={`${styleSelect}
              ${errors[id] ? "border-red-500 border-2" : "border-gray-300"} `}
              {...register(id, {
                required: {
                  value: required,
                  message: (
                    <>
                      <span className="capitalize">{name}</span>
                      <span> es requerido.</span>
                    </>
                  ),
                },
              })}
            >
              {options &&
                options.map((option) => (
                  <option key={option.value} value={option.value}>
                    {option.label}
                  </option>
                ))}
            </select>
          </>
        );

      case "checkbox":
        return (
          <div className="flex gap-2 items-center">
            <input
              id={id}
              type={type}
              value={value}
              label={label}
              className={styleCheckbox}
              {...register(id, {
                required: {
                  value: required,
                  message: errorCheckbox,
                },
              })}
            />
            <label
              className={`${label ? "visible" : "invisible"} ${
                errors[id] ? "text-red-500 dark:text-red-500" : "text-black"
              }`}
              htmlFor={id}
            >
              {toLink ? (
                <Link to={toLink} target="_blank">
                  <div className="underline hover:text-primary-color cursor-pointer">
                    {label}
                  </div>
                </Link>
              ) : (
                label
              )}
            </label>
          </div>
        );

      case "radio":
        return (
          <div className="flex gap-2 items-center">
            <input
              id={id}
              type={type}
              value={value}
              label={label}
              className={styleCheckbox}
              {...register(id, {
                required: {
                  value: required,
                  message: (
                    <>
                      <span className="capitalize">{name}</span>
                      <span> es requerido.</span>
                    </>
                  ),
                },
              })}
            />
            <label
              className={`${label ? "visible" : "invisible"} ${
                errors[id] ? "text-red-500 dark:text-red-500" : "text-black"
              }`}
              htmlFor={id}
            >
              {label}
            </label>
          </div>
        );
    }
  }

  return (
    <div className="pt-2">
      {renderField()}
      {errors[id] && (
        <p className="text-red-500 text-sm mt-2">{errors[id].message}</p>
      )}
    </div>
  );
};

export default FormField;
